var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e12ddae8b62306ca9687c9145285966159a1707e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["website@lit-fibre-ltd"]={id:"e12ddae8b62306ca9687c9145285966159a1707e"};
      